import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { baseURL } from '../constants/base.url';
import {
  ApiResponse,
  SupportListQuery,
  SupportListResponse,
  SupportTicket,
  UpdateSupportTicketDto,
  AddSupportNoteDto,
  GenerateWhatsAppLinkDto
} from '../models/support';

@Injectable({
  providedIn: 'root'
})
export class SupportService {

  private readonly url = `${baseURL}support`;

  constructor(private http: HttpClient) { }

  createTicket(payload: FormData): Observable<ApiResponse<{ ticket: SupportTicket; emailSent: boolean; whatsappLink: string }>> {
    return this.http.post<ApiResponse<{ ticket: SupportTicket; emailSent: boolean; whatsappLink: string }>>(this.url, payload);
  }

  generateWhatsAppLink(payload: GenerateWhatsAppLinkDto): Observable<ApiResponse<{ whatsappLink: string }>> {
    return this.http.post<ApiResponse<{ whatsappLink: string }>>(`${this.url}/whatsapp-link`, payload);
  }

  listTickets(query: SupportListQuery): Observable<ApiResponse<SupportListResponse>> {
    let params = new HttpParams();

    Object.entries(query || {}).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') return;
      params = params.set(key, String(value));
    });

    return this.http.get<ApiResponse<SupportListResponse>>(this.url, { params });
  }

  getTicketById(id: string): Observable<ApiResponse<SupportTicket>> {
    return this.http.get<ApiResponse<SupportTicket>>(`${this.url}/${id}`);
  }

  updateTicketStatus(id: string, payload: UpdateSupportTicketDto): Observable<ApiResponse<SupportTicket>> {
    return this.http.patch<ApiResponse<SupportTicket>>(`${this.url}/${id}/status`, payload);
  }

  addTicketNote(id: string, payload: AddSupportNoteDto): Observable<ApiResponse<SupportTicket>> {
    return this.http.patch<ApiResponse<SupportTicket>>(`${this.url}/${id}/note`, payload);
  }

  deleteTicket(id: string): Observable<ApiResponse<any>> {
    return this.http.delete<ApiResponse<any>>(`${this.url}/${id}`);
  }
}